import React, { memo, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Notes from 'midi/Notes.js';
import StepData from 'pattern/StepData.js';
import Track from 'track/Track.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import PianoRollGridStep from 'components/pianoroll/PianoRollGridStep.js';
import Resolution from 'engine/Resolution.js';
import ToggledPianoRollSteps from '../pianoroll2/ToggledPianoRollSteps.js';
import {getPagination} from 'components/pianoroll/PianoRollPagination.js';
import {mouseDown} from 'actions/index.js';
import {dragToggle} from 'actions/index.js';
import {dragStepTranspose} from 'actions/index.js';
import {setStepDragging} from 'actions/index.js';
import {
    setStepDataDragging,
    setStepToCopy,
    setSelectedFreeze,
    setSampleExplorerSelected
} from 'actions/index.js';
import {setIsDraggingDuration} from 'actions/index.js';
import {setPianoRollSelection} from 'actions/index.js';
import {setArrangementMouseX} from 'actions/index.js';
import {setPianoRollCursor} from 'actions/index.js';
import {setSelectedPianoRollSteps} from 'actions/index.js';
import {setTransposeDragging} from 'actions/index.js';
import {addStep} from 'operations/actions.js';
import {updateStepParameter} from 'operations/actions.js';
import {deleteStep} from 'operations/actions.js';
import {moveSteps} from 'operations/actions.js';
import {WIDTH, LEFT_SPACE} from '../pianoroll/constants.js';
import Colors from 'components/Colors.js';
import {useStepsMouse} from './useStepsMouse.js';
const DURATION_RESOLUTION = new Resolution(16, false);
const baseResolution = Track.baseResolution;

const PianoRollStepsContainer = memo((props) => { 
    const {
        scale,
        xScale,
        resolution,
        color,
        stepsLength,
        track,
        height,
        parentClassName,
        noteIndex,
        sequencerEngine,
        setSampleExplorerSelected
    } = props;

    let defaultHeight = 24;

    var barLength = parseInt(resolution.numSteps()) / 4;
    const {onMouseDown, onMouseUp, onMouseOver} = useStepsMouse(props);

    return (
        <div
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          onMouseMove={onMouseOver}
          className="grid-steps-container">
          <ToggledPianoRollSteps
            color={color}
            stepsLength={stepsLength}
            parentClassName={parentClassName}
            noteIndex={noteIndex}
            xScale={xScale}
            sequencerEngine={sequencerEngine}
            height={height}
            track={track}/>
        </div>
    );
});

function isNoteInSelection(selection, transpose) {
    if (selection === undefined) {
        return undefined;
    }
    
    if (transpose <= selection.transpose &&
        transpose > selection.transpose - selection.numNotes) {
        return selection;
    }

    return undefined;
}


const mapStateToProps = (state, props) => {
    let steps = state.tracks.trackSteps[
        props.track.subSequence.isTrack ?
            props.track.subSequence.id : props.track.id];
    let note = state.keyboard.notes[props.noteIndex];
    let noteTranspose = note === undefined ? 0 : note.getTranspose();
    return {
        stepsLength: steps === undefined ? 16 : steps.length,
        selection: isNoteInSelection(state.keyboard.pianoRollSelection, noteTranspose),
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        mouseDown: m => dispatch(mouseDown(m)),
        dragToggle: m => dispatch(dragToggle(m)),
        setStepDragging: step  => dispatch(setStepDragging(step)),
        setStepToCopy: step  => dispatch(setStepToCopy(step)),
        setTransposeDragging: transpose => dispatch(setTransposeDragging(transpose)),
        setDragStepTranspose: transpose => dispatch(dragStepTranspose(transpose)),
        setIsDraggingDuration: isDraggingDuration => dispatch(setIsDraggingDuration(isDraggingDuration)),
        setStepDataDragging: stepData => dispatch(setStepDataDragging(stepData)),
        setPianoRollSelection: (stepNumber, transpose, numSteps, numNotes) =>
            dispatch(setPianoRollSelection(stepNumber, transpose, numSteps, numNotes)),
        setSelectedPianoRollSteps: (steps) => dispatch(setSelectedPianoRollSteps(steps)),
        setSelectedFreeze: (freeze) => dispatch(setSelectedFreeze(freeze)),
        setPianoRollCursor: (cursor) => dispatch(setPianoRollCursor(cursor)),
        setArrangementMouseX: (mouseX) => dispatch(setArrangementMouseX(mouseX)),
        setSampleExplorerSelected: (x) => dispatch(setSampleExplorerSelected(x)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PianoRollStepsContainer);
